import React from 'react';
import { Modal, Spin } from 'antd';
import type { PhotoData } from '../../types/dashboard';

interface PhotoModalProps {
  selectedPhoto: PhotoData | null;
  fullPhotoUrl: string | null;
  photoLoading: boolean;
  onClose: () => void;
}

const PhotoModal: React.FC<PhotoModalProps> = ({ 
  selectedPhoto, 
  fullPhotoUrl, 
  photoLoading, 
  onClose 
}) => {
  return (
    <Modal
      open={selectedPhoto !== null}
      onCancel={onClose}
      footer={null}
      width="90vw"
      style={{ maxWidth: 1200 }}
      centered
      title={
        selectedPhoto ? (
          <div>
            <span>写真詳細 - {new Date((selectedPhoto.captured_at || '').replace(/Z$/, '')).toLocaleString()}</span>
            {selectedPhoto.gps_latitude && selectedPhoto.gps_longitude && (
              <span style={{ marginLeft: 16, fontSize: '14px', color: '#666' }}>
                📍 {selectedPhoto.gps_latitude.toFixed(6)}, {selectedPhoto.gps_longitude.toFixed(6)}
              </span>
            )}
          </div>
        ) : '写真詳細'
      }
    >
      {photoLoading ? (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>写真を読み込み中...</div>
        </div>
      ) : fullPhotoUrl ? (
        <div style={{ textAlign: 'center' }}>
          <img
            src={fullPhotoUrl}
            alt="Full size photo"
            style={{ 
              maxWidth: '100%', 
              maxHeight: '70vh', 
              objectFit: 'contain',
              borderRadius: 8
            }}
          />
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '60px 0' }}>
          写真の読み込みに失敗しました
        </div>
      )}
    </Modal>
  );
};

export default PhotoModal;